import React from 'react';

import InfoContent from './InfoContent';

const InfoSections = ({ course }) => {

  function orderByPosition(a, b) {
    if (a.position < b.position) return -1;
    if (a.position > b.position) return 1;
    return 0;
  }

  return (
    <div>
      {course?.info_section?.sort(orderByPosition)?.map((section) => {
        if (Object.values(section.content)?.length === 0) return null;
        return <InfoContent key={section.id} sectionData={section} />;
      })}
    </div>
  );
};

export default InfoSections;
